// Anonymous stats tracking. Never blocks the UI or link navigation.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const safePost = (path) => {
  try {
    fetch(`${API}${path}`, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
    }).catch(() => {
      /* intentionally ignored: anonymous stats must never surface errors to visitors */
    });
  } catch (_) {
    /* intentionally ignored: fetch unavailable (e.g. very old browser) */
  }
};

export const trackVisit = () => safePost("/stats/visit");
export const trackAndroid = () => safePost("/stats/android");
export const trackIos = () => safePost("/stats/ios");

export const fetchStats = () =>
  fetch(`${API}/stats`)
    .then((r) => (r.ok ? r.json() : { visitors: 0, android: 0, ios: 0 }))
    .catch(() => ({ visitors: 0, android: 0, ios: 0 }));
